import React, { useState } from 'react'
import { Popup } from 'semantic-ui-react'

const SocialIcon = ({ expert }) => {
    const [emailHover, setEmailHover] = useState(false)
    const [linkedinHover, setLinkedinHover] = useState(false)

    //functions
    const copyItem = (e, value) => {
        e.preventDefault()
        let aux = document.createElement('input')
        aux.setAttribute('value', value)
        document.body.appendChild(aux)
        aux.select()
        aux.setSelectionRange(0, 99999)
        document.execCommand('copy')
        document.body.removeChild(aux)
    }

    const renderEmailIcon = () => {
        return (
            <Popup
                trigger={
                    <a
                        href="# "
                        style={{ float: 'right', marginRight: '5px' }}
                        onMouseEnter={() => setEmailHover(true)}
                        onMouseLeave={() => setEmailHover(false)}
                        onClick={(e) => {
                            copyItem(e, expert.email)
                        }}
                    >
                        <Popup
                            trigger={
                                <img
                                    src={
                                        emailHover
                                            ? '/logos/email.svg'
                                            : '/logos/email-grey.svg'
                                    }
                                    className="social_pic"
                                    alt="email"
                                />
                            }
                            content="Copy"
                            style={{ zIndex: 9999 }}
                        />
                    </a>
                }
                content="Copied!"
                on="click"
                hideOnScroll
                style={{ zIndex: 9999 }}
            />
        )
    }

    const renderLinkedinIcon = () => {
        const linkedinUrl = expert.expert.publicLinks?.find((url) =>
            url.includes('linkedin.com')
        )
        if (!linkedinUrl) return null
        return (
            <Popup
                trigger={
                    <a
                        href="# "
                        style={{ float: 'right' }}
                        onMouseEnter={() => setLinkedinHover(true)}
                        onMouseLeave={() => setLinkedinHover(false)}
                        onClick={(e) => {
                            copyItem(e, linkedinUrl)
                        }}
                    >
                        <Popup
                            trigger={
                                <img
                                    src={
                                        linkedinHover
                                            ? '/logos/social.svg'
                                            : '/logos/social-grey.svg'
                                    }
                                    className="social_pic"
                                    alt="linkedin"
                                />
                            }
                            content="Copy"
                            style={{ zIndex: 9999 }}
                        />
                    </a>
                }
                content="Copied!"
                on="click"
                hideOnScroll
                style={{ zIndex: 9999 }}
            />
        )
    }

    return (
        <div style={{ float: 'right' }}>
            {renderEmailIcon()}
            {renderLinkedinIcon()}
        </div>
    )
}

export default SocialIcon
